import { render } from "./AdditionalTermsModal.vue?vue&type=template&id=561866e8&scoped=true"
import script from "./AdditionalTermsModal.vue?vue&type=script&lang=js"
export * from "./AdditionalTermsModal.vue?vue&type=script&lang=js"

import "./AdditionalTermsModal.scss?vue&type=style&index=0&id=561866e8&lang=scss&scoped=true&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-561866e8"]])

export default __exports__